import script from "./qr.vue?vue&type=script&setup=true&lang=js"
export * from "./qr.vue?vue&type=script&setup=true&lang=js"

import "./qr.vue?vue&type=style&index=0&id=6c19a124&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c19a124"]])

export default __exports__